var _line, _line2, _line3, _line4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConffetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 372,
    viewBox: "0 0 501 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 220.335,
    y1: 370.869,
    x2: 400.958,
    y2: 224.981,
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 223.622,
    y1: 237.909,
    x2: 307.715,
    y2: 169.649,
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.477655,
    y1: 334.047,
    x2: 228.487,
    y2: 149.886,
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 329.811,
    y1: 219.416,
    x2: 405.814,
    y2: 158.029,
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.583 60.9927C212.899 60.1376 214.933 58.5885 216.995 56.326C216.477 59.1554 216.596 61.5836 217.475 63.872C218.402 66.2878 220.144 68.4576 222.667 70.7462C219.165 70.0769 216.33 70.1516 213.849 71.1127C211.854 71.8855 210.159 73.2048 208.561 75.035C209.015 72.5605 208.91 70.3915 208.135 68.3482C207.213 65.9151 205.378 63.7693 202.666 61.5315C205.691 61.9821 208.24 61.8576 210.583 60.9927Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.678 315.469C429.994 314.614 432.028 313.065 434.09 310.802C433.572 313.632 433.692 316.06 434.57 318.348C435.498 320.764 437.239 322.934 439.762 325.222C436.26 324.553 433.425 324.628 430.944 325.589C428.95 326.362 427.254 327.681 425.656 329.511C426.11 327.037 426.005 324.868 425.23 322.824C424.308 320.391 422.473 318.246 419.761 316.008C422.786 316.458 425.335 316.334 427.678 315.469Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.735 129.496C183.298 128.919 184.684 127.929 186.056 126.53C185.815 128.344 185.952 129.957 186.542 131.493C187.173 133.136 188.295 134.62 189.874 136.139C187.601 135.789 185.692 135.897 183.99 136.557C182.687 137.061 181.557 137.87 180.505 138.956C180.697 137.4 180.569 135.989 180.059 134.643C179.428 132.979 178.242 131.502 176.541 130.008C178.473 130.215 180.161 130.076 181.735 129.496Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.858 331.482C333.731 330.79 335.361 329.467 337.067 327.465C336.507 329.889 336.531 331.884 337.245 333.742C337.987 335.676 339.456 337.405 341.65 339.295C338.699 338.631 336.403 338.626 334.433 339.389C332.763 340.036 331.374 341.218 330.036 342.916C330.565 340.739 330.56 338.911 329.916 337.214C329.181 335.275 327.635 333.573 325.277 331.731C327.867 332.215 329.961 332.182 331.858 331.482Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.578 185.071C456.452 184.38 458.081 183.056 459.787 181.055C459.227 183.478 459.251 185.474 459.965 187.331C460.707 189.265 462.176 190.994 464.37 192.885C461.419 192.221 459.123 192.215 457.153 192.978C455.483 193.626 454.094 194.807 452.756 196.506C453.285 194.329 453.28 192.501 452.636 190.804C451.901 188.864 450.355 187.162 447.997 185.321C450.587 185.805 452.681 185.771 454.578 185.071Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.506 291.458C188.379 290.767 190.009 289.443 191.715 287.442C191.155 289.865 191.179 291.86 191.892 293.718C192.635 295.652 194.104 297.381 196.298 299.272C193.347 298.608 191.051 298.602 189.081 299.365C187.411 300.012 186.022 301.194 184.684 302.893C185.213 300.716 185.208 298.888 184.564 297.191C183.829 295.251 182.283 293.549 179.925 291.708C182.514 292.192 184.609 292.158 186.506 291.458Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.332 3.89457C282.36 3.51527 283.264 2.83876 284.175 1.86024C283.966 3.0963 284.03 4.16855 284.419 5.18239C284.832 6.25672 285.594 7.22308 286.69 8.2329C285.154 7.95539 283.897 7.99922 282.791 8.42767C281.915 8.76728 281.165 9.33624 280.462 10.1181C280.64 9.0438 280.583 8.09205 280.241 7.19206C279.83 6.10847 279.026 5.15118 277.848 4.16225C279.169 4.34361 280.294 4.27786 281.332 3.89457Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.808 74.5136C275.835 74.1343 276.74 73.4577 277.65 72.4792C277.442 73.7153 277.506 74.7875 277.895 75.8014C278.307 76.8757 279.07 77.8421 280.165 78.8519C278.63 78.5744 277.373 78.6182 276.267 79.0467C275.39 79.3863 274.641 79.9552 273.937 80.7371C274.116 79.6628 274.058 78.711 273.717 77.811C273.306 76.7275 272.502 75.7702 271.324 74.7812C272.645 74.9626 273.77 74.8969 274.808 74.5136Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 488.064,
    y: 225.469,
    width: 9.84196,
    height: 9.84196,
    transform: "rotate(-12.7166 488.064 225.469)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 342.541,
    y: 60.7074,
    width: 9.84196,
    height: 9.84196,
    transform: "rotate(-12.7166 342.541 60.7074)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 422.541,
    y: 256.772,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(-12.7166 422.541 256.772)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 289.017,
    y: 126.677,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(-12.7166 289.017 126.677)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 246.73,
    y: 286.06,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(-12.7166 246.73 286.06)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.541,
    y: 116.772,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(-12.7166 125.541 116.772)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConffetti);
export default __webpack_public_path__ + "static/media/Conffetti.f3f923b8ebdde509037c9258fe192dd9.svg";
export { ForwardRef as ReactComponent };